import React from "react";
import { Box, Typography, Avatar } from "@mui/material";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import "./TestimonialCard.scss";

interface TestimonialCardProps {
  firstName: string;
  lastName: string;
  username: string;
  message: string;
  rating?: number;
  image?: string;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  firstName,
  lastName,
  username,
  message,
  rating = 5,
  image,
}) => {
  return (
    <Box className="testimonial-card">
      {/* Quote Icon + Message Row */}
      <Box className="testimonial-card__top">
        <svg
          width="45"
          height="38"
          viewBox="0 0 45 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {" "}
          <path
            d="M9.27973 37.376C6.80506 37.376 4.62906 36.4587 2.75173 34.624C0.917061 32.7894 -0.000272751 29.9947 -0.000272751 26.24C-0.000272751 22.528 0.618394 18.9654 1.85573 15.552C3.13573 12.096 4.71439 9.02404 6.59173 6.33604C8.46906 3.64803 10.4104 1.53603 12.4157 3.05176e-05L17.7917 2.04803C15.8291 4.30937 13.9944 7.10403 12.2877 10.432C10.6237 13.76 9.74906 17.024 9.66373 20.224C12.0531 20.4374 14.0157 21.2907 15.5517 22.784C17.1304 24.2774 17.9197 26.24 17.9197 28.672C17.9197 31.2747 17.0664 33.3867 15.3597 35.008C13.6531 36.5867 11.6264 37.376 9.27973 37.376ZM35.3917 37.376C32.9171 37.376 30.7411 36.4587 28.8637 34.624C27.0291 32.7894 26.1117 29.9947 26.1117 26.24C26.1117 22.528 26.7304 18.9654 27.9677 15.552C29.2477 12.096 30.8264 9.02404 32.7037 6.33604C34.5811 3.64803 36.5224 1.53603 38.5277 3.05176e-05L43.9037 2.04803C41.9411 4.30937 40.1064 7.10403 38.3997 10.432C36.7357 13.76 35.8611 17.024 35.7757 20.224C38.1651 20.4374 40.1277 21.2907 41.6637 22.784C43.2424 24.2774 44.0317 26.24 44.0317 28.672C44.0317 31.2747 43.1784 33.3867 41.4717 35.008C39.7651 36.5867 37.7384 37.376 35.3917 37.376Z"
            fill="#EBD28D"
          />{" "}
        </svg>

        <Typography className="testimonial-card__message">{message}</Typography>
      </Box>

      {/* Bottom Section: Profile + Rating */}
      <Box className="testimonial-card__bottom">
        <Box className="testimonial-card__user">
          <Avatar
            src={image || "/assets/default-avatar.png"}
            alt={`${firstName} ${lastName}`}
            className="testimonial-card__avatar"
          />
          <Box>
            <Typography className="testimonial-card__name">
              {firstName} {lastName}
            </Typography>
            <Typography className="testimonial-card__username">
              @{username}
            </Typography>
          </Box>
        </Box>

        <Box className="testimonial-card__rating">
          {[...Array(rating)].map((_, i) => (
            <StarRoundedIcon key={i} className="testimonial-card__star" />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default TestimonialCard;
